(function ($) {
    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

    // Already booked view

    if ($('.page-template-booking-page .already-booked-apartment-screen').length > 0) {
        $('.booking-interest-form-success .button').on('click', function(e) {
            const formWrapper = $(this).closest('.form-wrapper');
            const email = formWrapper.find('#email')[0].value;
            const newsletter = formWrapper.find('#liven-newsletter')[0].checked;
            const apartment_id = formWrapper.data('apartment-id');
            const language = formWrapper.data('language');

            formWrapper.find('.input-wrap').removeClass('error');
            formWrapper.find('.response-error').removeClass('active');

            if (!email || !validateEmail(email)) {
                formWrapper.find('.input-wrap').addClass('error');
            } else {
                formWrapper.addClass('loading');

                $.post(liven.ajax_url, {
                    'action': 'record_booking_interest',
                    'email': email,
                    'apartment_id': apartment_id,
                    'language': language,
                    'newsletter': newsletter
                }, function (response) {
                    if (response.success) {
                        formWrapper.find('.response-success').addClass('active');
                    } else {
                        formWrapper.find('.response-error').addClass('active');
                    }

                    setTimeout(function () {
                        formWrapper.removeClass('loading');
                    }, 1000)
                });
            }
        })
    }

    // Booking view

    const formInputs = {
        fullName: {
            input: $('#name'),
            required: true
        },
        identificationCode: {
            input: $('#identification-code'),
            required: true
        },
        email: {
            input: $('#email'),
            required: true
        },
        phone: {
            input: $('#phone-number'),
            required: true
        },
        companyName: {
            input: $('#company-name'),
            required: false
        },
        companyCode: {
            input: $('#company-code'),
            required: false
        },
        companyAddress: {
            input: $('#company-address'),
            required: false
        },
        companyRepresentativeName: {
            input: $('#representative-name'),
            required: false
        }
    }

    if ($('.page-template-booking-page .book-apartment-screen').length > 0) {
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                location.reload();
            }
        });

        function getTimeRemaining(timestampEnd) {
            let totalTime = timestampEnd - Date.now();
            let seconds = Math.floor((totalTime / 1000) % 60);
            let minutes = Math.floor((totalTime / 1000 / 60) % 60);

            return {
                'total': totalTime,
                'minutes': minutes,
                'seconds': seconds
            };
        }

        const token = $('.book-apartment-screen').data('token');
        const expiration_timestamp = Date.parse($('.book-apartment-screen').data('reservation-timestamp-expires') + "Z");

        if (token) {
            const url = new URL(window.location);
            url.searchParams.set('token', token);
            window.history.pushState({}, '', url);
        }

        if (getTimeRemaining(expiration_timestamp).total > 0) {
            $(".booking-time .minutes").text(('0' + getTimeRemaining(expiration_timestamp).minutes).slice(-2))
            $(".booking-time .seconds").text(('0' + getTimeRemaining(expiration_timestamp).seconds).slice(-2))

            const timerInterval = setInterval(function() {
                if (getTimeRemaining(expiration_timestamp).total <= 0) {
                    clearInterval(timerInterval);
                    location.reload();
                } else {
                    $(".booking-time .minutes").text(('0' + getTimeRemaining(expiration_timestamp).minutes).slice(-2))
                    $(".booking-time .seconds").text(('0' + getTimeRemaining(expiration_timestamp).seconds).slice(-2))
                }
            }, 1000);
        }

        $('.basic-select').select2();

        if ($('.booking-form-wrap #company')[0].checked) {
            formInputs.fullName.required = false;
            formInputs.identificationCode.required = false;
            formInputs.companyAddress.required = true
            formInputs.companyName.required = true
            formInputs.companyCode.required = true
            formInputs.companyRepresentativeName.required = true
        }

        $('.trigger-terms-modal').on('click', function() {
            $('body').addClass('overflow-hidden');
            $('.terms-and-conditions-popup').addClass('active');
        });

        $('.terms-and-conditions-popup .button').on('click', function() {
            $('body').removeClass('overflow-hidden');
            $('.terms-and-conditions-popup').removeClass('active');
            $('#terms-conditions')[0].checked = true
        });

        $('.terms-and-conditions-popup .close-popup').on('click', function() {
            $('body').removeClass('overflow-hidden');
            $('.terms-and-conditions-popup').removeClass('active');
        });

        $('.close-button').on('click', function() {
           const link = $(this).data('href');
           const apiBase = $(this).data('api-base');

           $('.book-apartment-screen .loader').addClass('active');

            $.ajax({
                "url": `${apiBase}/apartment/unreserve`,
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json"
                },
                "data": JSON.stringify({
                    "reservation_identity_token": token
                })
            }).done(function (response) {
                location.href = link;
            });
        });
    }

    $(".booking-form-wrap #company").change(function () {
        $('.booking-form-wrap .company-details').toggleClass('active');
        $('.booking-form-wrap .person-details').toggleClass('hidden');

        formInputs.fullName.required = !formInputs.fullName.required;
        formInputs.identificationCode.required = !formInputs.identificationCode.required;
        formInputs.companyAddress.required = !formInputs.companyAddress.required
        formInputs.companyName.required = !formInputs.companyName.required
        formInputs.companyCode.required = !formInputs.companyCode.required
        formInputs.companyRepresentativeName.required = !formInputs.companyRepresentativeName.required
    });

    $('.page-template-booking-page .book-apartment-screen .start-booking').on('click', function() {
        let valid = true;

        for (let [key, element] of Object.entries(formInputs)) {
            const inputWrapper = element.input.closest('.wrap');
            const errorMessage = inputWrapper.find('.error-message');

            if (element.required && !element.input.val().trim().length) {
                errorMessage.text(errorMessage.data('message-required'));
                inputWrapper.addClass('error');
                valid = false;
            }
            else if (key === "email" && element.required && !validateEmail(element.input.val())) {
                errorMessage.text(errorMessage.data('message-format'));
                inputWrapper.addClass('error');
                valid = false;
            }
            else {
                element.input.closest('.wrap').removeClass('error');
            }
        }

        if (!$('#terms-conditions')[0].checked) {
            $('.checkbox-wrap.terms-conditions').addClass('error')
            valid = false;
        } else {
            $('.checkbox-wrap.terms-conditions').removeClass('error')
        }

        if (!$('input[name="swedbank_bic"]:checked').length) {
            $('.payment-methods').addClass('error')
            valid = false;
        } else {
            $('.payment-methods').removeClass('error')
        }

        if (valid) {
            $('.book-apartment-screen .loader').addClass('active');
            $('body').addClass('overflow-hidden');

            const currentFailureUrl = $('input[name="failure_url"]').val();
            const excludedParams = ['swedbank_bic', 'terms-conditions', 'swedbank_country', 'reservation_identity_token', 'success_url', 'failure_url', 'language'];
            let formInputString = '';

            $('.booking-form').serializeArray().forEach((input) => {
                if (!excludedParams.includes(input.name) && input.value) {
                    if (input.name === "name") {
                        formInputString += `&full_name=${input.value}`
                    } else {
                        formInputString += `&${input.name}=${input.value}`
                    }
                }
            })

            $('input[name="failure_url"]').val(currentFailureUrl + formInputString);

            $('.booking-form').submit();
        } else {
            $("html, body").animate({ scrollTop: $('.error').offset().top - 10 });
        }
    });

    for (let [key, element] of Object.entries(formInputs)) {
        element.input.on('focusin change', function() {
            $(this).closest('.wrap').removeClass('error');
        })
    }

    $('.error-modal .modal-error-close').on('click', function() {
        $('.error-modal').removeClass('active');
    })
})(jQuery);